export const AUTH_MEMBER_SET = 'AUTH_MEMBER_SET';
